import { MDText } from 'i18n-react';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { getSaleType } from '../BiddingSectionCTAStateController/getSaleType';
import { PriceAndSaleInfo } from '../PriceAndSaleInfo/PriceAndSaleInfo';
import { useHasValuationsToDisplay } from '../Valuations/useHasValuationsToDisplay';
import { Valuations } from '../Valuations/Valuations';

import underOfferTexts from './UnderOffer.texts';

import styles from './UnderOffer.module.scss';

const LocalT = new MDText(underOfferTexts);

export const UnderOffer: React.FC = () => {
	const { bidding, state } = useVehicleData();
	const hasValuationsToDisplay = useHasValuationsToDisplay();

	const { highestBidOrOffer } = bidding;

	const saleType = getSaleType(state);

	return (
		<>
			<PriceAndSaleInfo badgeVariant="underOffer" />
			{highestBidOrOffer ? (
				<div className={styles.highestBidContainer}>
					<span>{LocalT.translate(`highestBidOrOffer.${saleType}`)}</span>
					<span className={styles.bidAmount}>{highestBidOrOffer.displayValue}</span>
				</div>
			) : null}
			{hasValuationsToDisplay ? <Valuations /> : null}
		</>
	);
};
